/** LABEL TRANSLATIONS */
import {
  FUEL_VALUES,
  HEAVY_TRUCK_TRANSMISSION_VALUES,
  TRANSMISSION_VALUES,
} from '@/features/attributes/constants/attributes'

export const TRANSMISSION_LABELS: Record<number, string> = {
  [TRANSMISSION_VALUES.AUTOMATIC]: 'listing:attributes.car_transmission.automatic',
  [TRANSMISSION_VALUES.MANUAL]: 'listing:attributes.car_transmission.manual',
  [TRANSMISSION_VALUES.OTHER]: 'listing:attributes.car_transmission.other',
  [TRANSMISSION_VALUES.SEMI_AUTOMATIC]: 'listing:attributes.car_transmission.semi_automatic',
}

export const HEAVY_TRUCK_TRANSMISSION_LABELS: Record<string, string> = {
  [HEAVY_TRUCK_TRANSMISSION_VALUES.MANUAL_GEAR]:
    'listing:attributes.heavy_truck_transmission.manual',
  [HEAVY_TRUCK_TRANSMISSION_VALUES.AUTOMATIC_GEAR]:
    'listing:attributes.heavy_truck_transmission.automatic',
  [HEAVY_TRUCK_TRANSMISSION_VALUES.AMT]: 'listing:attributes.heavy_truck_transmission.amt',
  [HEAVY_TRUCK_TRANSMISSION_VALUES.OTHER]: 'listing:attributes.heavy_truck_transmission.other',
}

export const FUEL_TYPE_LABELS: Record<string, string> = {
  [FUEL_VALUES.DIESEL]: 'listing:attributes.fuel_type.diesel',
  [FUEL_VALUES.ELECTRIC]: 'listing:attributes.fuel_type.electric',
  [FUEL_VALUES.GAS]: 'listing:attributes.fuel_type.gas',
  [FUEL_VALUES.HYBRID]: 'listing:attributes.fuel_type.hybrid',
  [FUEL_VALUES.OTHER]: 'listing:attributes.fuel_type.other',
}
